import {
  ASSET_CLASS_MODELS,
  MODEL_TYPES,
  RANGE_SELECTOR_MODELS,
  MSTAR_SELECTOR_MODELS,
  PRODUCT_TYPE_MODELS
} from '../../shared/screener-constants';

const highRiskReturnsSection = {
  sectionLabel: 'Higher risk & higher returns',
  cards: [
    {
      title: 'High Performance',
      description: 'Investments with highest 3-year average returns',
      icon: 'Perform',
      mappings: {
        modelType: MODEL_TYPES.RANGE_SELECTORS,
        modelKey: RANGE_SELECTOR_MODELS.PERFORMANCE,
        modelIndex: 4
      }
    },
    {
      title: 'Higher Risk',
      description: 'More volatile investments with greater potential returns',
      icon: 'Up',
      mappings: {
        modelType: MODEL_TYPES.RANGE_SELECTORS,
        modelKey: RANGE_SELECTOR_MODELS.RISK,
        modelIndex: 4
      }
    },
    {
      title: 'High Yield',
      description: 'Investments which generate the highest amount of income',
      icon: 'Income',
      mappings: {
        modelType: MODEL_TYPES.RANGE_SELECTORS,
        modelKey: RANGE_SELECTOR_MODELS.YIELD,
        modelIndex: 4
      }
    }
  ]
};

const safeAffordableSection = {
  sectionLabel: 'More safe & affordable',
  cards: [
    {
      title: 'Low Risk',
      description: 'Less volatile investments with lower potential returns',
      icon: 'Down',
      mappings: {
        modelType: MODEL_TYPES.RANGE_SELECTORS,
        modelKey: RANGE_SELECTOR_MODELS.RISK,
        modelIndex: 0
      }
    },
    {
      title: 'Low Expense',
      description: 'Less expensive investments with fewer operating and management fees',
      icon: 'LowExpense',
      mappings: {
        modelType: MODEL_TYPES.RANGE_SELECTORS,
        modelKey: RANGE_SELECTOR_MODELS.EXPENSE,
        modelIndex: 0
      }
    }
  ]
};

const perfVsPeersSection = {
  sectionLabel: 'Performance vs peers',
  cards: [
    {
      title: 'High Ratings vs Peers',
      description: 'Investments rated four or five stars by Morningstar™',
      icon: 'StarOutline',
      mappings: {
        modelType: MODEL_TYPES.MSTAR_SELECTORS,
        modelKey: MSTAR_SELECTOR_MODELS.RATING
      }
    },
    {
      title: 'High Performance vs Peers',
      description: 'Investments with highest 3-year average returns in their category',
      icon: 'Perform',
      mappings: {
        modelType: MODEL_TYPES.RANGE_SELECTORS,
        modelKey: RANGE_SELECTOR_MODELS.PERF_VS_PEERS,
        modelIndex: 4
      }
    },
    {
      title: 'Low Risk vs Peers',
      description: 'Investments with lowest risk in their category',
      icon: 'Down',
      mappings: {
        modelType: MODEL_TYPES.RANGE_SELECTORS,
        modelKey: RANGE_SELECTOR_MODELS.RISK_VS_PEERS,
        modelIndex: 0
      }
    }
  ]
};

const assetClassSection = {
  sectionLabel: 'Asset classes',
  cards: [
    {
      title: 'Equity',
      description: 'Investments mostly comprised of stocks',
      icon: 'Equities',
      mappings: {
        modelType: MODEL_TYPES.ASSET_CLASS,
        modelKey: ASSET_CLASS_MODELS.EQUITIES
      }
    },
    {
      title: 'Fixed Income',
      description: 'Investments mostly comprised of corporate or government bonds',
      icon: 'FixedIncome',
      mappings: {
        modelType: MODEL_TYPES.ASSET_CLASS,
        modelKey: ASSET_CLASS_MODELS.FIXEDINCOME
      }
    },
    {
      title: 'Guaranteed',
      description: 'Annuities that provide a guaranteed fixed return',
      icon: 'Check',
      mappings: {
        modelType: MODEL_TYPES.ASSET_CLASS,
        modelKey: ASSET_CLASS_MODELS.GUARANTEED
      }
    },
    {
      title: 'Money Market',
      description: 'Short-term investments including government-issued securities & CDs',
      icon: 'Market',
      mappings: {
        modelType: MODEL_TYPES.ASSET_CLASS,
        modelKey: ASSET_CLASS_MODELS.MONEYMARKET
      }
    },
    {
      title: 'Multi-Asset',
      description: 'Investments comprised of both equities and fixed income',
      icon: 'Coins',
      mappings: {
        modelType: MODEL_TYPES.ASSET_CLASS,
        modelKey: ASSET_CLASS_MODELS.MULTIASSET
      }
    },
    {
      title: 'Real Estate',
      description: 'Investments with direct exposure to commercial properties',
      icon: 'House',
      mappings: {
        modelType: MODEL_TYPES.ASSET_CLASS,
        modelKey: ASSET_CLASS_MODELS.REALESTATE
      }
    }
  ]
};

const productTypeSection = {
  sectionLabel: 'Product type',
  cards: [
    {
      title: 'Variable Annuities',
      description: 'Designed to provide long-term performance and growth potential',
      icon: 'Bag',
      mappings: {
        modelType: MODEL_TYPES.PRODUCT_TYPE,
        modelKey: PRODUCT_TYPE_MODELS.VARIABLEANNUITIES
      }
    },
    {
      title: 'Fixed Annuity',
      description: 'Guaranteed daily growth without the risk of losing money',
      icon: 'FixedAnnuity',
      mappings: {
        modelType: MODEL_TYPES.PRODUCT_TYPE,
        modelKey: PRODUCT_TYPE_MODELS.FIXEDANNUITIES
      }
    },
    {
      title: 'Mutual Fund',
      description: "Professionally invested to match the fund's objective",
      icon: 'Mutual',
      mappings: {
        modelType: MODEL_TYPES.PRODUCT_TYPE,
        modelKey: PRODUCT_TYPE_MODELS.MUTUALFUNDS
      }
    },
    // will add this back for authenticate experience
    // {
    //   title: 'RetirePlus Pro Models',
    //   description: 'Professionally managed investment portfolios unique to your institution',
    //   icon: 'RetirePlus',
    //   mappings: {
    //     modelType: MODEL_TYPES.PRODUCT_TYPE,
    //     modelKey: PRODUCT_TYPE_MODELS.RETIREPROPLUSMODELS
    //   }
    // },
    // {
    //   title: 'RetirePlus Models',
    //   description: 'Professionally managed investment portfolios unique to your institution',
    //   icon: 'RetirePlus',
    //   mappings: {
    //     modelType: MODEL_TYPES.PRODUCT_TYPE,
    //     modelKey: PRODUCT_TYPE_MODELS.RETIREPLUSMODELS
    //   }
    // },
    {
      title: 'FDIC Insured Products',
      description: 'Bank-related products insured by the federal government',
      icon: 'Product',
      mappings: {
        modelType: MODEL_TYPES.PRODUCT_TYPE,
        modelKey: PRODUCT_TYPE_MODELS.FDICINSUREDPRODUCTS
      }
    }
  ]
};

/*
const bondsSection = {
  sectionLabel: 'Bonds',
  cards: [
    {
      title: 'Short Duration',
      description: 'Relatively low exposure to interest rate changes',
      icon: 'ShortDuration'
    },
    {
      title: 'Medium Duration',
      description: 'Moderate exposure to interest rate changes',
      icon: 'MediumDuration'
    },
    {
      title: 'Long Duration',
      description: 'Relatively high exposure to interest rate changes',
      icon: 'LongDuration'
    },
    {
      title: 'High Credit Quality',
      description: 'Average credit risk is very low',
      icon: 'HighCredit'
    },
    {
      title: 'Moderate Credit Quality',
      description: 'Average credit rating is above high yield, but not highest quality',
      icon: 'MediumCredit'
    },
    {
      title: 'Low Credit Quality',
      description: 'Average Credit rating is high yield',
      icon: 'LowCredit'
    },
    {
      title: 'Income Generating',
      description: 'Distribution yield is top 20% of all investments',
      icon: 'Income'
    }
  ]
};

const equitiesSection = {
  sectionLabel: 'Equities',
  cards: [
    {
      title: 'Value',
      description: 'Investments with stocks that have low prices relative to fundamentals',
      icon: 'Value'
    },
    {
      title: 'Blend',
      description: 'Investments with both value and growth stocks',
      icon: 'Blend'
    },
    {
      title: 'Growth',
      description: 'Investments with companies expected to grow sales & earnings relatively fast',
      icon: 'Growth'
    },
    {
      title: 'Large',
      description: 'Average company size is relatively large',
      icon: 'Large'
    },
    {
      title: 'Mid',
      description: 'Average company size is in the middle of the range',
      icon: 'Mid'
    },
    {
      title: 'Small',
      description: 'Average company size is small, higher potential growth/risk',
      icon: 'Small'
    }
  ]
};
*/

// add these back to get bonds back
//bondsSection,
//equitiesSection
const presetCategories = () => {
  return [
    highRiskReturnsSection,
    safeAffordableSection,
    perfVsPeersSection,
    assetClassSection,
    productTypeSection
  ];
};

export default presetCategories;
